import { animate, cubicBezier } from 'animejs';
import globalVar from '../utils/globalVar'

class Module14Map {
  constructor() {
    const section = document.querySelector('.module-14-map');
    if (!section) return;

    let map;
    let markers            = [];
    let markerMap          = {};   // id → marker lookup for fast icon swaps
    let searchPin          = null; // Temporary pin for the user's searched address
    let useAdvancedMarkers = false; // true when mapId is set + AdvancedMarkerElement available
    let hideSuggestions    = () => {}; // assigned below once the dropdown is built
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.header = document.querySelector('header');
      cache.closeBtn = document.querySelectorAll('.module-14-map .info-box .close_box');
      cache.openBtn = document.querySelectorAll('.module-14-map .open_box');
    }

    let registerEvents = () => {
      if (cache.closeBtn) {
        cache.closeBtn.forEach(closeBtn => {
          closeBtn.addEventListener('click', closeInfoBox.bind(closeBtn));
        });
      }
      if (cache.openBtn) {
        cache.openBtn.forEach(openBtn => {
          openBtn.addEventListener('click', openInfoBox.bind(openBtn));
        });
      }
    }

    let openInfoBox = function(){
      const box = document.getElementById(this.dataset.info);
      let sidebar = this.closest('.sidebar_sellers').offsetWidth/window.innerWidth*100;
      let width = "95%";
      if (globalVar.mobile.matches) {
        width = "100%";
        sidebar = "0%"
      }
      box.style.display = 'block';
      if (globalVar.mobile.matches) {
       document.querySelector('html').classList.add('overflow');
        document.querySelector('body').classList.add('overflow');
      }
      if(!cache.header.classList.contains('open')) {
          cache.header.classList.add('up');
        }
      animate(box, {
          width: [sidebar, width],
          opacity: [0, 1],
          duration: 600,
          ease: cubicBezier(0.567, -0.013,0.493,0.98),
      });
    }

    let closeInfoBox = function(){
      const parent = this.closest('.info-box');
      let sidebar = this.closest('.module-14-map').querySelector('.sidebar_sellers').offsetWidth/window.innerWidth*100;
      if (globalVar.mobile.matches) {
        sidebar = "0%"
      }
      animate(parent, {
          width: [parent.offsetWidth/window.innerWidth*100, sidebar],
          opacity: [1, 0],
          duration: 600,
          ease: cubicBezier(0.567, -0.013,0.493,0.98),
          onComplete: () => {
            parent.style.display = 'none';
            if (globalVar.mobile.matches) {
              document.querySelector('html').classList.remove('overflow');
              document.querySelector('body').classList.remove('overflow');
              if(!globalVar.desktop.matches) {
                cache.header.classList.remove('up');
              }
            }
          }
      });
    }

    // ─── SVG pin icons ───────────────────────────────────────────────
    const PIN_SELLER = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="30" viewBox="0 0 22 30">
        <path d="M11 0C4.925 0 0 4.925 0 11c0 8.25 11 19 11 19S22 19.25 22 11C22 4.925 17.075 0 11 0z" fill="white"/>
        <circle cx="11" cy="11" r="4" fill="#10233F"/>
      </svg>`
    )}`;

    const PIN_ACTIVE = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 30 40">
        <path d="M15 0C6.716 0 0 6.716 0 15c0 11.25 15 25 15 25S30 26.25 30 15C30 6.716 23.284 0 15 0z" fill="white"/>
        <circle cx="15" cy="15" r="5.5" fill="#10233F"/>
      </svg>`
    )}`;

    // Creates an <img> element used as AdvancedMarkerElement content
    function createPinImg(url, w, h) {
      const img = document.createElement('img');
      img.src = url;
      img.width = w;
      img.height = h;
      img.style.display = 'block';
      return img;
    }

    // Swaps a marker between active (large) and inactive (small) state
    function setMarkerState(marker, active) {
      if (useAdvancedMarkers) {
        const img = marker.content;
        if (!img) return;
        img.src    = active ? PIN_ACTIVE : PIN_SELLER;
        img.width  = active ? 30 : 22;
        img.height = active ? 40 : 30;
      } else {
        if (active) {
          marker.setIcon({ url: PIN_ACTIVE, anchor: new google.maps.Point(15, 40) });
        } else {
          marker.setIcon({ url: PIN_SELLER, anchor: new google.maps.Point(11, 30) });
        }
      }
    }

    // ─── Dark navy map style (used only when mapId is NOT set) ───────
    // When a mapId IS set, configure the dark theme in Google Cloud Console
    // instead: https://console.cloud.google.com/google/maps-apis/studio/styles
    const MAP_STYLES = [
      { elementType: 'geometry',            stylers: [{ color: '#071830' }] },
      { elementType: 'labels',              stylers: [{ visibility: 'off' }] },
      {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#10233F' }, { weight: 0.8 }, { visibility: 'on' }]
      },
      {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [{ color: '#10233F' }, { weight: 0.5 }, { visibility: 'on' }]
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.fill',
        stylers: [{ color: '#6b8ab5' }, { visibility: 'on' }]
      },
      {
        featureType: 'administrative.locality',
        elementType: 'labels.text.stroke',
        stylers: [{ color: '#0e1b2d' }, { visibility: 'on' }]
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [{ color: '#10233F' }]
      },
      {
        featureType: 'road',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      },
      {
        featureType: 'transit',
        stylers: [{ visibility: 'off' }]
      }
    ];

    // ─── Init ─────────────────────────────────────────────────────────
    // ACF loads Google Maps asynchronously, so `google` may not be defined
    // yet when window.onload fires. Poll until it's ready (max 10 s).
    waitForGoogle()
      .then(initMap)
      .catch((err) => console.error('[Module14Map]', err));

    function waitForGoogle() {
      if (typeof google !== 'undefined' && google.maps) return Promise.resolve();
      return new Promise((resolve, reject) => {
        let elapsed = 0;
        const id = setInterval(() => {
          elapsed += 100;
          if (typeof google !== 'undefined' && google.maps) {
            clearInterval(id);
            resolve();
          } else if (elapsed >= 10000) {
            clearInterval(id);
            reject(new Error('Google Maps API did not load within 10 s'));
          }
        }, 100);
      });
    }

    function initMap() {
      const mapEl = document.getElementById('map');
      if (!mapEl) {
        console.error('[Module14Map] #map element not found in DOM');
        return;
      }

      const sellers = document.querySelectorAll('.sidebar_sellers_list .seller');

      // AdvancedMarkerElement requires a mapId.
      // Set one via the ACF global option "api_google_map_id" — it is output
      // as data-map-id on the #map element in module-14-map.php.
      // When a mapId is active, JS styles are not supported: recreate the dark
      // theme in Google Cloud Console instead.
      const mapId = mapEl.dataset.mapId || null;
      useAdvancedMarkers = !!(mapId && google.maps.marker?.AdvancedMarkerElement);

      map = new google.maps.Map(mapEl, {
        center: { lat: 30, lng: 15 },
        zoom: 3,
        minZoom: 2,
        ...(mapId ? { mapId } : { styles: MAP_STYLES }),
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
      });

      // Build a marker for every seller
      sellers.forEach((seller) => {
        const lat = parseFloat(seller.dataset.lat);
        const lng = parseFloat(seller.dataset.lng);
        if (isNaN(lat) || isNaN(lng)) return;

        let marker;
        if (useAdvancedMarkers) {
          marker = new google.maps.marker.AdvancedMarkerElement({
            position: { lat, lng },
            map,
            title: seller.querySelector('h4')?.textContent?.trim() ?? '',
            content: createPinImg(PIN_SELLER, 22, 30),
          });
        } else {
          marker = new google.maps.Marker({
            position: { lat, lng },
            map,
            title: seller.querySelector('h4')?.textContent?.trim() ?? '',
            icon: {
              url: PIN_SELLER,
              anchor: new google.maps.Point(11, 30),
            },
          });
        }

        // Store seller id and coordinates for lookups (AdvancedMarkerElement
        // does not expose getPosition(), so we keep our own lat/lng).
        marker._sellerId = seller.id;
        marker._lat = lat;
        marker._lng = lng;

        // Clicking a map pin → highlight seller in sidebar
        marker.addListener('click', () => {
          activateSeller(seller.id);
          map.panTo({ lat, lng });
        });

        // Clicking a seller card → zoom to city level and center on its pin
        seller.addEventListener('click', () => {
          activateSeller(seller.id);
          map.panTo({ lat, lng });
          map.setZoom(12);
        });

        markers.push(marker);
        markerMap[seller.id] = marker;
      });

      // ─── Programmatic autocomplete (classic Places API) ──────────────
      // AutocompleteService + PlacesService keep the native <input> and build
      // our own dropdown — no widget UI, no shadow DOM, no extra buttons.
      const input = document.getElementById('addressInput');
      if (input && google.maps.places) {
        const acService     = new google.maps.places.AutocompleteService();
        const placesService = new google.maps.places.PlacesService(map);

        const dropdown = document.createElement('ul');
        dropdown.className = 'map-autocomplete-dropdown';
        dropdown.hidden = true;
        document.body.appendChild(dropdown);

        let debounceTimer = null;

        function positionDropdown() {
          const r = input.getBoundingClientRect();
          dropdown.style.top   = (r.bottom + window.scrollY) + 'px';
          dropdown.style.left  = (r.left   + window.scrollX) + 'px';
          dropdown.style.width = r.width + 'px';
        }

        hideSuggestions = function () {
          dropdown.hidden = true;
          dropdown.innerHTML = '';
        };

        function fetchSuggestions(query) {
          if (!query || query.length < 2) { hideSuggestions(); return; }
          acService.getPlacePredictions(
            { input: query, language: document.documentElement.lang || 'en' },
            (predictions, status) => {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                hideSuggestions();
                return;
              }
              dropdown.innerHTML = '';
              predictions.forEach((prediction) => {
                const li = document.createElement('li');
                li.textContent = prediction.description;
                li.addEventListener('mousedown', (e) => {
                  e.preventDefault(); // keep focus on input until we're done
                  input.value = prediction.structured_formatting?.main_text || prediction.description;
                  hideSuggestions();
                  placesService.getDetails(
                    { placeId: prediction.place_id, fields: ['geometry'] },
                    (result, detailStatus) => {
                      if (detailStatus === google.maps.places.PlacesServiceStatus.OK && result.geometry?.location) {
                        const lat = result.geometry.location.lat();
                        const lng = result.geometry.location.lng();
                        placeSearchPin(lat, lng);
                        findClosestMarker(lat, lng);
                      }
                    }
                  );
                });
                dropdown.appendChild(li);
              });
              positionDropdown();
              dropdown.hidden = false;
            }
          );
        }

        input.addEventListener('input', () => {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(() => fetchSuggestions(input.value.trim()), 300);
        });
        input.addEventListener('blur',    () => setTimeout(hideSuggestions, 150));
        input.addEventListener('keydown', (e) => { if (e.key === 'Escape') hideSuggestions(); });
      }

      const form = document.getElementById('formMap');
      if (form) form.addEventListener('submit', handleSearch);

      const geolocBtn = document.querySelector('.btn_geoloc');
      if (geolocBtn) geolocBtn.addEventListener('click', handleGeoloc);

      const resetBtn = document.querySelector('.module-14-map .reset.btn');
      if (resetBtn) resetBtn.addEventListener('click', resetMap);
    }

    // ─── Geolocation handler ──────────────────────────────────────────
    function handleGeoloc() {
      if (!navigator.geolocation) return;

      const btn = document.querySelector('.btn_geoloc');
      if (btn) btn.classList.add('loading');

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (btn) btn.classList.remove('loading');
          findClosestMarker(pos.coords.latitude, pos.coords.longitude);
        },
        () => {
          if (btn) btn.classList.remove('loading');
          console.warn('[Module14Map] Geolocation denied or unavailable');
        },
        { timeout: 8000 }
      );
    }

    // ─── Reset map to initial state ───────────────────────────────────
    function resetMap() {
      // Reset map view
      map.setCenter({ lat: 30, lng: 15 });
      map.setZoom(3);

      // Remove search pin
      if (searchPin) {
        if (useAdvancedMarkers) searchPin.map = null;
        else searchPin.setMap(null);
        searchPin = null;
      }

      // Clear active seller card + reset its marker icon
      const prev = document.querySelector('.sidebar_sellers_list .seller.active');
      if (prev) {
        prev.classList.remove('active');
        const prevMarker = markerMap[prev.id];
        if (prevMarker) setMarkerState(prevMarker, false);
      }

      // Scroll sidebar list back to top
      const list = document.querySelector('.sidebar_sellers_list');
      if (list) list.scrollTo({ top: 0, behavior: 'smooth' });

      // Clear the address input and close any open suggestions
      hideSuggestions();
      const inputEl = document.getElementById('addressInput');
      if (inputEl) inputEl.value = '';
    }

    // ─── Search handler ───────────────────────────────────────────────
    function handleSearch(e) {
      e.preventDefault();
      const address = document.getElementById('addressInput')?.value?.trim();
      if (!address) return;

      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const loc = results[0].geometry.location;
          placeSearchPin(loc.lat(), loc.lng());
          findClosestMarker(loc.lat(), loc.lng());
        } else {
          showError(address);
        }
      });
    }

    // ─── Drop a pin at the searched location ─────────────────────────
    function placeSearchPin(lat, lng) {
      if (searchPin) {
        if (useAdvancedMarkers) searchPin.map = null;
        else searchPin.setMap(null);
        searchPin = null;
      }
      if (useAdvancedMarkers) {
        searchPin = new google.maps.marker.AdvancedMarkerElement({
          position: { lat, lng },
          map,
          content: createPinImg(PIN_SELLER, 22, 30),
          zIndex: 999,
        });
      } else {
        searchPin = new google.maps.Marker({
          position: { lat, lng },
          map,
          icon: {
            url: PIN_SELLER,
            anchor: new google.maps.Point(11, 30),
          },
          zIndex: 999,
        });
      }
      searchPin._lat = lat;
      searchPin._lng = lng;
    }

    // ─── Find closest seller and highlight it ─────────────────────────
    function findClosestMarker(searchLat, searchLng) {
      if (!markers.length) return;

      let closestIndex = 0;
      let shortestDist = Infinity;

      markers.forEach((marker, i) => {
        const d = haversine(searchLat, searchLng, marker._lat, marker._lng);
        if (d < shortestDist) {
          shortestDist = d;
          closestIndex = i;
        }
      });

      const closest = markers[closestIndex];
      activateSeller(closest._sellerId);

      // Fit map to show both the searched point and the closest seller
      const bounds = new google.maps.LatLngBounds();
      bounds.extend({ lat: searchLat, lng: searchLng });
      bounds.extend({ lat: closest._lat, lng: closest._lng });

      // Cap zoom once after fitBounds settles
      google.maps.event.addListenerOnce(map, 'idle', () => {
        if (map.getZoom() > 13) map.setZoom(13);
      });

      map.fitBounds(bounds);
    }

    // ─── Activate a seller card, update its map marker, and scroll into view ──
    function activateSeller(id) {
      // Deactivate previous card + reset its marker icon
      const prev = document.querySelector('.sidebar_sellers_list .seller.active');
      if (prev) {
        prev.classList.remove('active');
        const prevMarker = markerMap[prev.id];
        if (prevMarker) setMarkerState(prevMarker, false);
      }

      const target = document.getElementById(id);
      if (!target) return;

      // Activate new card + enlarge its marker
      target.classList.add('active');
      const marker = markerMap[id];
      if (marker) setMarkerState(marker, true);

      const list = document.querySelector('.sidebar_sellers_list');
      if (!list) return;

      // Smooth-scroll the list panel to the chosen card
      const targetTop = target.getBoundingClientRect().top;
      const listTop   = list.getBoundingClientRect().top;
      const offset    = targetTop - listTop + list.scrollTop;

      list.scrollTo({ top: offset, behavior: 'smooth' });
    }

    // ─── Haversine distance (km) ──────────────────────────────────────
    function haversine(lat1, lng1, lat2, lng2) {
      const R    = 6371;
      const dLat = rad(lat2 - lat1);
      const dLng = rad(lng2 - lng1);
      const a    =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(rad(lat1)) * Math.cos(rad(lat2)) * Math.sin(dLng / 2) ** 2;
      return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    }

    function rad(deg) { return deg * Math.PI / 180; }

    // ─── Inline error feedback ────────────────────────────────────────
    function showError(address) {
      const input = document.getElementById('addressInput');
      if (!input) return;
      input.classList.add('input-error');
      input.placeholder = `"${address}" not found`;
      input.value = '';
      setTimeout(() => {
        input.classList.remove('input-error');
        input.placeholder = input.getAttribute('placeholder') || '';
      }, 3000);
    }

    initFunc();
  }
}

export { Module14Map }
